import { Injectable } from '@angular/core';
import { ApModalService } from 'webcommon/core-ui';
import { FpMessageCreatedDto, FpUserPropertiesDto } from 'webcommon/shared';
import { FPMessageCreateModalComponent } from './fp-message-create-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FPMessageCreateModalService {
  constructor(
    private apModalService: ApModalService,
  ) { }

  openModal(
    baseId: string,
    fromUserName: string | null,
    messageDefaultUrgencyId: string,
    messageTypeId: string,
    messageTypeName: string,
    messageSubTypeId: string,
    messageSubTypeName: string,
    userProperties: FpUserPropertiesDto | null)
  : Promise<FpMessageCreatedDto | null> {

    const initialState = {
      baseId,
      fromUserName,
      messageDefaultUrgencyId,
      messageSubTypeId,
      messageSubTypeName,
      messageTypeId,
      messageTypeName,
      userProperties,
    };

    const p = this.apModalService.showComponentModal(FPMessageCreateModalComponent, {
      class: 'emds-modal-full fp-modal',
      ignoreBackdropClick: true,
      initialState,
    });

    return p;
  }
}
